export default __webpack_public_path__ + "static/media/amazon.fe3fcc75.svg";